import yup from './../FormValidation/yupCustomMethods';

export default yup;
